import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";

const searchResultsTemplate = "SermonSearchResults";
const bookTemplate = "SermonSearchBooks";
const tagTemplate = "SermonSearchTags";

export class SermonSearchModule {
    // Class Properties
    sermonDetailsUrl = "";
    seriesDetailUrl = "";

    static Init() {

        DEBUG && console.info('Sermon Search *--> Init');

        var elements = document.querySelectorAll('[data-component="SermonSearch"]');

        elements.forEach(element => {
            var congregationId = element.getAttribute('data-congregationId');
            var sermonDetailsUrl = element.getAttribute('data-sermonUrl');
            var seriesDetailUrl = element.getAttribute('data-seriesUrl');
            var search = element.getAttribute('data-search');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info('Init Sermon Search');
            DEBUG && console.info(`Element:                 ${element.id}`);
            DEBUG && console.info(`Sermon Details:          ${sermonDetailsUrl}`);
            DEBUG && console.info(`Series Details:          ${seriesDetailUrl}`);
            DEBUG && console.info(`Search Term:             ${search}`);
            DEBUG && console.info(`Congregation:            ${congregationId}`);
            DEBUG && console.info('**************************************************');

            this.sermonDetailsUrl = sermonDetailsUrl;
            this.seriesDetailUrl = seriesDetailUrl;

            this.InitSermonSearch(element, congregationId, search);
        });
    }



    static async InitSermonSearch(element, congregationId, search) {
        // Get Elements
        const btnSermonSearchBooks = document.getElementById("btnSermonSearchBooks");
        const btnSermonSearchTags = document.getElementById("btnSermonSearchTags");
        const btnClearSermonSearch = document.getElementById("btnClearSermonSearch");
        const panelSermonSearchResults = document.getElementById("panelSermonSearchResults");
        const panelSermonTagResults = document.getElementById("panelSermonTagResults");
        const btnSearchSermon = document.getElementById("btnSearchSermon");

        const searchBookEl = document.getElementById("BookID");
        const searchTagEl = document.getElementById("TagID");
        const searchCongregationEl = document.getElementById("CongregationID");
        const searchTermEl = document.getElementById("SearchTerm");

        // Localize This
        let self = this;

        btnSermonSearchBooks.addEventListener("click", function () {
            self.GetBibleCounts(congregationId, panelSermonTagResults, searchBookEl, searchTermEl);
        });

        btnSermonSearchTags.addEventListener("click", function () {
            self.GetTagCounts(congregationId, panelSermonTagResults, searchTagEl, searchTermEl);
        });

        btnClearSermonSearch.addEventListener("click", function () {
            self.ClearSearchResults();
        });

        btnSearchSermon.addEventListener("click", function () {
            self.PreClear();
            self.Search();
        })


        searchTermEl.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                DEBUG && console.info('*--> Sermon Search Enter Key');
                self.PreClear();
                self.Search();
            }
        });

        searchTermEl.addEventListener('input', function (event) {
            const searchText = event.target.value;
            if (searchText === '') {
                // The search field has been cleared
                DEBUG && console.log('*==> Sermon Search field cleared');
                // Handle the cleared search field event
                self.ClearSearchResults();
            }
        });

        var lastSearch = sessionStorage.getItem("SermonSearch");

        if (search) {
            DEBUG && console.info('Executing Search for ' + search);
        }

        if (lastSearch) {
            DEBUG && console.info('Executing Session Search');
            
            var lastSearchObj = JSON.parse(lastSearch);

            DEBUG && console.info(lastSearchObj);

            // Set Search Values
            searchBookEl.value = lastSearchObj.BookID;
            searchTagEl.value = lastSearchObj.TagID;
            searchTermEl.value = lastSearchObj.SearchTerm;

            // Redo Last Search
            self.Search();
        }
    }
     


    static async GetBibleCounts(congregationId, element, searchBookEl, searchTermEl) {
        var data = await api.getData(`Sermon/GetBibleBooksWithSermonCounts?congregationId=${congregationId}`);
        DEBUG && console.info(data);

        var dataObj = { "data": data };

        var content = await TemplateService.GetRenderedTemplate(bookTemplate, dataObj);

        element.innerHTML = content;

        // Add Tag Events
        // Wire up tags to Search Click
        let bookElements = document.querySelectorAll('[data-book="true"]');

        let self = this;

        bookElements.forEach((el) => {
            el.addEventListener('click', function () {
                searchTermEl.value = this.getAttribute("data-text");
                searchBookEl.value = this.getAttribute("data-id");
                self.Search();
            });
        });
    }



    static async GetTagCounts(congregationId, element, searchTagEl, searchTermEl) {
        var data = await api.getData(`Sermon/GetTagsWithSermonCount?congregationId=${congregationId}`);
        DEBUG && console.info(data);

        var dataObj = { "data": data };

        var content = await TemplateService.GetRenderedTemplate(tagTemplate, dataObj);

        element.innerHTML = content;

        // Add Tag Events
        // Wire up tags to Search Click
        let tagElements = document.querySelectorAll('[data-tag="true"]');

        let self = this;

        tagElements.forEach((tag) => {
            tag.addEventListener('click', function () {
                searchTermEl.value = this.getAttribute("data-text");
                searchTagEl.value = this.getAttribute("data-id");
                self.Search();
            });
        });
    }



    static PreClear() {
        const searchBookEl = document.getElementById("BookID");
        const searchTagEl = document.getElementById("TagID");
        searchBookEl.value = "";
        searchTagEl.value = "";
    }



    static Search() {
        const searchBookEl = document.getElementById("BookID");
        const searchTagEl = document.getElementById("TagID");
        const searchCongregationEl = document.getElementById("CongregationID");
        const searchTermEl = document.getElementById("SearchTerm");
        DEBUG && console.log('Search Clicked');

        api.getApiData(`Sermon/GetSermonSearch?congregationId=${searchCongregationEl.value}&searchTerm=${searchTermEl.value}&BookID=${searchBookEl.value}&TagID=${searchTagEl.value}`)
            .then(data => {
                // Create SessionVariable
                var lastSearch = {};
                lastSearch.BookID = searchBookEl.value;
                lastSearch.TagID = searchTagEl.value;
                lastSearch.CongregationID = searchCongregationEl.value;
                lastSearch.SearchTerm = searchTermEl.value;

                sessionStorage.setItem("SermonSearch", JSON.stringify(lastSearch));

                this.ShowSearchResults(data);
            });

    }



    static async ShowSearchResults(data) {
        DEBUG && console.info("**--> Showing Search Results");        

        const panelSermonSearchResults = document.getElementById("panelSermonSearchResults");
        const panelClearSearch = document.getElementById("panelClearSearch");


        if (!data.BookID && !data.TagID) {
            // Hide or Clear Tags / books
            const panelSermonTagResults = document.getElementById("panelSermonTagResults");
            panelSermonTagResults.innerHTML = "";
        }

        var dataObj = {};
        dataObj.Series = data.Series;
        dataObj.Sermons_Books = data.Sermons_Books;
        dataObj.Sermons_Search = data.Sermons_Search;
        dataObj.Sermons_Tags = data.Sermons_Tags;
        dataObj.ResultsCount = data.Series.length + data.Sermons_Books.length + data.Sermons_Search.length + data.Sermons_Tags.length;
        dataObj.SearchTerm = data.SearchTerm;
        dataObj.SeriesUrl = this.seriesDetailUrl;
        dataObj.SermonUrl = this.sermonDetailsUrl;

        DEBUG && console.info(dataObj);

        var content = await TemplateService.GetRenderedTemplate(searchResultsTemplate, dataObj);

        panelSermonSearchResults.innerHTML = content;

        panelClearSearch.style.display = "block";
        panelSermonSearchResults.style.display = "block";

        panelSermonSearchResults.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    static ClearSearchResults() {
        const searchBookEl = document.getElementById("BookID");
        const searchTagEl = document.getElementById("TagID");
        const searchTermEl = document.getElementById("SearchTerm");
        const panelSermonSearchResults = document.getElementById("panelSermonSearchResults");
        const panelClearSearch = document.getElementById("panelClearSearch");

        searchBookEl.value = "";
        searchTagEl.value = "";
        searchTermEl.value = "";
        panelSermonSearchResults.innerHTML = "";
        panelSermonSearchResults.style.display = "none";
        panelClearSearch.style.display = "none";
    }
    
}


